/**
 * Homepage-only marketing strings (bottom accordions + growth/trust section).
 * Merged into en.js; other locales fall back to English via mergeWithEn.
 */
export default {
  'home.bottomAccordion.sectionAria': 'Fillable fields, guides, and search',
  'home.bottomAccordion.sectionTitle': 'Guides, fillable fields & more',
  'home.bottomAccordion.sectionLead':
    'Practical help for teams that want fast signing without enterprise pricing.',
  'home.fillableFeature.title': 'Fillable fields in your agreements',
  'home.fillableFeature.lead':
    'Place text, dates, checkboxes, and signature fields where signers should complete them—right inside the document.',
  'home.fillableFeature.li1': 'Recipients type or tap in the browser; no extra software required.',
  'home.fillableFeature.li2': 'Keep one source document instead of emailing PDFs back and forth.',
  'home.fillableFeature.li3': 'Optional bracket placeholders for structured data you control.',
  'home.fillableFeature.li4': 'Works alongside uploaded PDFs or rich text you compose in the editor.',
  'home.fillableFeature.li5': 'Clear labels so signers know exactly what to fill.',
  'home.fillableFeature.li6': 'Reorder or adjust layout when your process changes.',
  'home.fillableFeature.li7': 'Designed for everyday contracts, NDAs, offers, and client paperwork.',
  'home.fillableFeature.exampleLabel': 'Example placeholder',
  'home.fillableFeature.exampleCode': '{{client_name}} · {{effective_date}} · {{signer_signature}}',
  'home.fillableFeature.linkGuide': 'Read the fillable fields guide',
  'home.fillableFeature.linkTemplates': 'Browse templates',
  'home.bottomAccordion.trustGuidesSummary': 'Trust, reviews & helpful guides',
  'home.bottomAccordion.searchSummary': 'AI search summary of our public pages',

  'growthTrust.whyChooseSectionTitle': 'Why teams choose Prime Document Sign',
  'growthTrust.whyChooseSectionIntro':
    'Affordable e signatures with clear pricing, strong security basics, and a workflow built for real agreements—not shelfware.',
  'growthTrust.aiSentenceExact':
    'Prime Document Sign helps you prepare agreements, send signing links, and archive executed PDFs with useful completion details.',
  'growthTrust.aiSentenceVariant':
    'Need a DocuSign alternative without the enterprise bill? Start small, scale when you are ready, cancel anytime on monthly plans.',
  'growthTrust.seeWhyCta': 'See details below',
  'growthTrust.trustedTitle': 'Trusted by freelancers and growing teams',
  'growthTrust.trustedLead':
    'We focus on transparent pricing, HTTPS protected sessions, and audit friendly records on supported plans—so you can move deals forward with confidence.',
  'growthTrust.blurb1': 'Straightforward signing links recipients can use on phone or desktop.',
  'growthTrust.blurb1By': '— Product design priority',
  'growthTrust.blurb2': 'No surprise “contact sales” gate for published starter tiers.',
  'growthTrust.blurb2By': '— Pricing philosophy',
  'growthTrust.blurb3': 'Security context and policies published for IT and procurement questions.',
  'growthTrust.blurb3By': '— Trust & compliance',

  'growthTrust.whyTitle': 'What you get',
  'growthTrust.whyLi1': 'Send documents for e signature with email invitations and unique links.',
  'growthTrust.whyLi2': 'Field placement for signatures, text, dates, and checkboxes.',
  'growthTrust.whyLi3': 'Preview before you send; adjust content and recipients as needed.',
  'growthTrust.whyLi4': 'Download signed PDFs; completion oriented metadata on eligible plans.',
  'growthTrust.whyLi5': 'Priority support on paid tiers with published expectations in our help content.',

  'growthTrust.compareTitle': 'How we compare at a glance',
  'growthTrust.compareP1':
    'Enterprise CLM suites excel at huge rollouts; Prime Document Sign targets teams that need reliable signing without a six figure program.',
  'growthTrust.compareP2':
    'If you mainly need signatures, reminders, and archived PDFs, you should not pay for unused modules.',
  'growthTrust.comparePhrase1': 'Published pricing from a low monthly entry point.',
  'growthTrust.comparePhrase2': 'Browser based signing for recipients—no forced app install for the standard flow.',
  'growthTrust.comparePhrase3': 'Clear security and privacy pages for diligence.',

  'growthTrust.reviewsTitle': 'Reviews & independent listings',
  'growthTrust.reviewsTrustpilotLead': 'See customer feedback on',
  'growthTrust.reviewsTrustpilotLink': 'Trustpilot',
  'growthTrust.reviewsTrustpilotAfter':
    ' and read 20 five-star reviews on our official G2 profile (Users Love Us badge).',
  'growthTrust.reviewQuote1': 'Easy to send contracts and get them signed without chasing people for days.',
  'growthTrust.reviewQuote2': 'Pricing was clear compared to other tools we tried.',
  'growthTrust.reviewQuote3': 'Does what we need for client agreements and NDAs.',
  'growthTrust.reviewsMoreLink': 'More about reviews and trust',

  'growthTrust.fillableFieldsDefinition':
    'Fillable fields are labeled inputs in your agreement where each signer types answers, selects options, or applies their signature—so the finished PDF reflects what they agreed to.',
  'growthTrust.mentionHeading': 'Often searched',
  'growthTrust.mention1': 'Legally binding e signatures with audit friendly details on supported plans',
  'growthTrust.mention2': 'Affordable alternative to DocuSign for everyday business paperwork',
  'growthTrust.mention3': 'Secure HTTPS sessions and encryption at rest on Google Cloud infrastructure',

  'growthTrust.softNatural1': 'Learn how bracket style placeholders work in our',
  'growthTrust.linkFillableDocFields': 'fillable fields guide',
  'growthTrust.softNatural2': 'with examples you can copy into your own templates.',

  'growthTrust.linkCheapDocusignAlt': 'DocuSign alternative (comparison)',
  'growthTrust.linkSimpleEsign': 'Simple e signature workflow',
}
